import { ChipTypes } from '@lib/components/Chip/Chip';
import { Option } from '@lib/interfaces/form';
import { TFunction } from 'i18next';

export default function getChipTypesOptions({
  t,
  chipTypes,
}: {
  t: TFunction<'translation', undefined>;
  chipTypes?: ChipTypes[];
}) {
  if (chipTypes) {
    return chipTypes
      .filter(
        (chipType) =>
          chipType !== ChipTypes.chipFilter &&
          chipType !== ChipTypes.chipDisabled,
      )
      .map((chipType) => ({
        value: chipType,
        label: chipType ? t(chipType.replace('chip-', '')) : chipType,
        color: chipType,
      }));
  }
  return (Object.keys(ChipTypes) as Array<keyof typeof ChipTypes>)
    .filter(
      (chipType) =>
        ChipTypes[chipType] !== ChipTypes.chipFilter &&
        ChipTypes[chipType] !== ChipTypes.chipDisabled,
    )
    .map((chipType) => ({
      value: ChipTypes[chipType],
      label: ChipTypes[chipType]
        ? t(ChipTypes[chipType].replace('chip-', ''))
        : ChipTypes[chipType],
      color: ChipTypes[chipType],
    })) as Option[];
}
